import React from 'react';

interface IProps {
  fillColor?: string;
}

const GridOverlayIcon:React.FC<IProps> = (props: IProps) => {
  return (  
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="16" height="16" rx="1.5" stroke={props.fillColor ? props.fillColor : "white"}/>
    <line x1="4.125" y1="1.5" x2="4.125" y2="15.5" stroke={props.fillColor ? props.fillColor : "white"} strokeLinecap="round"/>
    <line x1="8.25" y1="1.5" x2="8.25" y2="15.5" stroke={props.fillColor ? props.fillColor : "white"} strokeLinecap="round"/>
    <line x1="12.375" y1="1.5" x2="12.375" y2="15.5" stroke={props.fillColor ? props.fillColor : "white"} strokeLinecap="round"/>
    <line x1="0.5" y1="4.125" x2="16.5" y2="4.125" stroke={props.fillColor ? props.fillColor : "white"} strokeLinecap="round"/>
    <line x1="0.5" y1="8.25" x2="16.5" y2="8.25" stroke={props.fillColor ? props.fillColor : "white"} strokeLinecap="round"/>
    <line x1="0.5" y1="12.375" x2="16.5" y2="12.375" stroke={props.fillColor ? props.fillColor : "white"} strokeLinecap="round"/>
    
    </svg>
    
  )
}

export default GridOverlayIcon;